
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.468 2l-7.55 19.626M29.775 9.914l-3.02 7.85M9.877 13.74l-4.53 11.775M34.653 6.155l-3.02 7.85M26.565 17.823l-6.04-15.7M31.38 13.998l-1.51-3.925M12.894 21.45l-3.02-7.85","stroke":"#3DAFB8","stroke-width":"2","stroke-linecap":"round"}}),_c('rect',{attrs:{"y":"32.132","width":"40","height":"1.868","rx":".934","fill":"#000C1F"}})])
          )
        }
      }
    